var map = {
	"./All_notifications_black.svg": "7219",
	"./abnormal_notification_Color.svg": "3825",
	"./abnormal_notification_White.svg": "fafd",
	"./abnormal_notification_black.svg": "9888",
	"./all_notifications_white.svg": "61b7",
	"./appointments_black.svg": "8f49",
	"./appointments_white.svg": "2e12",
	"./attach_black.svg": "0d35",
	"./attach_white.svg": "a062",
	"./blood_pressure_black.svg": "26fa",
	"./blood_pressure_grey.svg": "8bad",
	"./blood_pressure_primary.svg": "62f8",
	"./blood_pressure_white.svg": "a570",
	"./burger_menu_color.svg": "2cc9",
	"./cholesterol_meter_White.svg": "db0c",
	"./cholesterol_meter_black.svg": "afea",
	"./cholesterol_meter_grey.svg": "ece2",
	"./cholesterol_meter_primary.svg": "84d0",
	"./clipboard_text_black.svg": "cd50",
	"./clipboard_text_white.svg": "d277",
	"./dashboard_black.svg": "1c44",
	"./dashboard_white.svg": "8ca9",
	"./devices_black.svg": "6608",
	"./devices_white.svg": "70d9",
	"./doctor_black.svg": "a6b5",
	"./doctor_primary.svg": "24df",
	"./doctor_secondary.svg": "63ab",
	"./drop_down_arrow_White.svg": "a034",
	"./drop_down_arrow_black.svg": "b615",
	"./edit_black.svg": "5562",
	"./edit_white.svg": "6823",
	"./endoscope.svg": "5854",
	"./glucose_meter_black.svg": "d8b3",
	"./glucose_meter_grey.svg": "ab42",
	"./glucose_meter_primary.svg": "a384",
	"./glucose_meter_whtie.svg": "1f87",
	"./license-icon-black.svg": "6549",
	"./license-icon.svg": "984f",
	"./medical_note.svg": "1146",
	"./medical_team_black.svg": "5123",
	"./medical_team_white.svg": "74ba",
	"./messages_notification_black.svg": "912d",
	"./messages_notification_white.svg": "ab2f",
	"./missed_notification_black.svg": "c293",
	"./missed_notification_color.svg": "bbbc",
	"./missed_notification_white.svg": "a8e0",
	"./monitoring_plan_black.svg": "04a4",
	"./monitoring_plan_white.svg": "0dec",
	"./nurse_black.svg": "1850",
	"./nurse_secondary.svg": "dfcb",
	"./oxymeter_White.svg": "7c75",
	"./oxymeter_black.svg": "ddf5",
	"./oxymeter_grey.svg": "ce5f",
	"./oxymeter_primary.svg": "cb62",
	"./patient_black.svg": "f3ce",
	"./patient_secondary.svg": "42c5",
	"./patient_white.svg": "f449",
	"./patients_black.svg": "2f62a",
	"./patients_white.svg": "3676",
	"./profile_black.svg": "09b9",
	"./profile_whiet.svg": "261a",
	"./scale_black.svg": "7e43",
	"./scale_grey.svg": "fdc0",
	"./scale_primary.svg": "5028",
	"./scale_white.svg": "0ff2",
	"./see_more_black.svg": "afef",
	"./see_more_white.svg": "b436",
	"./send_button_black.svg": "1bb0",
	"./send_button_white.svg": "dd17",
	"./setings_black.svg": "bf83",
	"./settings_white.svg": "5d09",
	"./sign_out_black.svg": "a0dc",
	"./sign_out_white.svg": "b6755",
	"./supportBlack.svg": "9ad9",
	"./supportWhite.svg": "3ab1",
	"./thermometer_White.svg": "9669",
	"./thermometer_black.svg": "59c0",
	"./thermometer_grey.svg": "a241",
	"./thermometer_primary.svg": "2951",
	"./verifireDark.svg": "6626",
	"./verifireWhite.svg": "45d6",
	"./videocall_black.svg": "1ec4",
	"./videocall_white.svg": "8d9a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";